<template>
  <div>

     <!-- <button @click="toXcx" style="width: 300px; height: 100px;"> 点击跳回小程序</button> -->
  </div>
</template>

<script>
import wx from "weixin-js-sdk"
import th from "element-ui/src/locale/lang/th";
export default {
  data() {
    return {
      urlId:"",
      relUri:""
    };
  },
  created() {
    console.log("this.$route：",this.$route);
    this.getUrl()
  },
  methods:{
    getUrl(){
      // 使用原生JavaScript获取完整URL参数，避免#号后的值丢失
      let url = window.location.href;
      console.log("完整URL:", url);
      
      // 首先尝试从URL中直接提取url参数
      let urlParam = this.getQueryParam('url');
      this.relUri = urlParam || "/pages/index/index";
      
      console.log("解析出的url参数:", urlParam);
      console.log("this.relUri:", this.relUri);
      
      if(this.relUri.indexOf("http")>-1){
        window.location.href = this.relUri;
      }else {
        this.toXcx();
      }
    },
    
    // 辅助方法：从完整URL中提取指定参数
    getQueryParam(name) {
      // 改进的方法，能够获取包含#号的完整参数值
      let url = window.location.href;
      
      // 直接使用参数名，不需要编码
      // 查找参数名的起始位置，确保是完整的参数名（前面是?或&或#）
      let paramRegex = new RegExp('[?&#]' + name + '=([^&]*)');
      console.log("paramRegex:", paramRegex);
      let match = url.match(paramRegex);
      
      if (!match || match.length < 2) {
        return null;
      }
      
      // match[1] 直接包含参数值部分，不包含等号
      let value = match[1];
      console.log("提取到的参数值:", value);
      
      // 解码URL参数值
      return decodeURIComponent(value.replace(/\+/g, ' '));
    },
    
    toXcx(){
      console.log("this.relUri", this.relUri);
      wx.miniProgram.redirectTo({
        url: this.relUri
      });
    },
  },

};
</script>

<style>
body{
  background: #f4f4f4
}

</style>



// WEBPACK FOOTER //
// src/views/home/toXcx.vue